import React from "react";
import { Row, Col } from "react-bootstrap";

import { daysUntil, expiringInDays } from "utils/helper";

const SamExclusionItems = ({ samItems, onChangeHandler, selectedItems }) => {
  return (
    <React.Fragment>
      {samItems.length ? (
        <div className="dt-each mb-2">
          {/* <div className="mb-1"><strong>SamExclusions</strong></div> */}
          {samItems.map((item, i) => {
            let unverifiedlabel = "";
            let unverifiedBtnClass = "";
            let label = "";
            let btnClass = "";
            if (!item.SAM_Verified) {
              unverifiedlabel = "Unverified";
              unverifiedBtnClass = "bg-info";
            }

            if (item.SAM_ExclusionEndDate) {
              const expirationDate = new Date(item.SAM_ExclusionEndDate);
              const daysRemaining = daysUntil(expirationDate);
              label = expiringInDays(daysRemaining);
              if (daysRemaining < 0) {
                btnClass = "bg-danger";
              } else {
                btnClass = "bg-light-red";
              }
            }

            return (
              <Row key={i}>
                <Col>
                  <input
                    type="checkbox"
                    id={`psv_item_sam_${item.provider.toString()}_${i}`}
                    checked={
                      selectedItems.some(
                        (selectedItem) =>
                          selectedItem.ProviderID === item.provider &&
                          selectedItem.SamExclusions &&
                          selectedItem.SamExclusions.includes(item._id)
                      ) ||
                      (item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false)
                    }
                    onChange={(e) => onChangeHandler(e, "SamExclusions", item)}
                    disabled={
                      item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false
                    }
                  />
                  <label
                    htmlFor={`psv_item_sam_${item.provider.toString()}_${i}`}
                  >
                    <span className="ml-1">SAM Exclusions</span>{" "}
                    {unverifiedlabel ? (
                      <span className={`badge ${unverifiedBtnClass}`}>
                        {unverifiedlabel}
                      </span>
                    ) : null}{" "}
                    {label ? (
                      <span className={`badge ${btnClass}`}>{label}</span>
                    ) : null}{" "}
                    {item.submitted_to_verify ? (
                      <span className="badge bg-secondary">In Process</span>
                    ) : null}
                  </label>
                </Col>
              </Row>
            );
          })}
        </div>
      ) : null}
    </React.Fragment>
  );
};
export default SamExclusionItems;
